import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel, { Optional } from "@/__main__/data-model.mjs";

export const model = {
  browserClient: String,
  // Logins via OAuth do not have an IP address
  ip: Optional(String),
  isCurrentSession: Boolean,
  operatingSystem: String,
  sessionCreatedAt: Date,
  sessionExpiry: Date,
  sessionTrackerId: String,
} satisfies ModelDefinition;

const ActiveSessionsModel = createModel({
  data: {
    activeSessions: [model],
  },
}).transform([model], (data) => data.data.activeSessions);

export type ActiveSessions = FromModel<typeof ActiveSessionsModel>;

export default ActiveSessionsModel;
